import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VideoCallService {

  accountCode = 'expeed';
  apiKey = '206B2B9C-B71F-4341-8DB9-6B5ABB5444B7';

  constructor(private http: HttpClient) { }

  initCall(username, password, receiver): Observable<any> {
    const command = {
      'secretkey': 'sb2a3wxsea6cko6qamq8bnkkpakapjebfhxiih4elfxfcdqgz7jv0xeqgynsbkru',
      'uris': [
        [
          {
            'init': {
              'commands': [
                {
                  'setUser': {
                    'username': username,
                    'password': password
                  }
                },
                {
                  'setAddressBook': {
                    'enabled': false
                  }
                },
                {
                  'setFirstTutorial': {
                    'enabled': false
                  }
                }
              ]
            }
          },
          {
            'onIdle': {
              'timeout': 20,
              'commands': [
                {
                  'exit': {}
                }
              ]
            }
          },
          {
            'onEndCall': {
              'commands': [
                {
                  'exit': {}
                }
              ]
            }
          },
          {
            'showLocalVideo': {}
          },
          {
            'call': {
              'username': receiver,
            }
          }
        ]
      ]
    };

    return this.http.post('https://api.vsee.com/uri/create?apikey=grxyvqkuce6np1fft5saepgthoq3ba5evg8nds5u9f0xmjbgilyrbx8lrjiyyju8', command);
  }

  guestSignIn(firstname: string, lastname: string) {
    const header = new HttpHeaders();
    header.append('X-ApiKey', this.apiKey);
    header.append('X-AccountCode', this.accountCode);

    const body = new FormData();
    body.append('first_name', 'Minh');
    body.append('last_name', 'Nguyen');

    return this.http.post;

  }
}
